import {
  RolodexEntryJson,
  RolodexEntryType,
} from 'types/rolodex/rolodexEntries'
import { parseString } from 'utils/parsingHelpers'

import { GeckoEntryBase } from './geckoEntry'
import {
  parseRiskScenarioRiskSelection,
  type RiskScenarioRiskSelection,
} from './geckoRiskScenario'

// Gate 0 form; 1 completed for each asset. HFS Specific.
export interface RiskGate0FormData extends Record<string, unknown> {
  // Link to the evaluated scenario (selected in the Gate 0 workflow).
  scenarioId?: string
  // Project Information
  dateSubmitted?: string
  vid?: string
  projectId?: string
  opportunityThreatName?: string
  projectName?: string
  projectSponsor?: string
  projectOwner?: string
  felSubmittedBy?: string
  projectManagerCapital?: string
  site?: string
  gate?: string
  projectType?: string
  unitName?: string
  totalInstalledCosts?: string
  estimateQuality?: string
  majorCapital?: string
  fel1Accountable?: string
  estimatedCostForFel1?: string
  riskLevel?: string
  turnaroundRequired?: string
  turnaroundEvent?: string
  scheduleConstraints?: string
  // Risk Data
  riskThreatId?: string
  actionItemId?: string
  actionItemDueDate?: string
  mitigatedRisk?: RiskScenarioRiskSelection
  mitigatedRiskJustification?: string
  // Project Team & SMEs — keyed by GATE0_TEAM_ROLES key
  team?: Record<string, string>
  // Basis
  premise?: string
  threatToPremise?: string
  riskScenario?: string
  safeguards?: string
  recommendedSolutions?: string
  sustainingAdditionalInfo?: string
}

export class GeckoRiskGate0Form extends GeckoEntryBase<
  RiskGate0FormData,
  {
    organization: string
    site: string
    unit?: string
  }
> {
  private constructor(json: RolodexEntryJson) {
    super(
      json,
      {
        scenarioId: parseString(json.data.scenarioId),
        dateSubmitted: parseString(json.data.dateSubmitted),
        vid: parseString(json.data.vid),
        projectId: parseString(json.data.projectId),
        opportunityThreatName: parseString(json.data.opportunityThreatName),
        projectName: parseString(json.data.projectName),
        projectSponsor: parseString(json.data.projectSponsor),
        projectOwner: parseString(json.data.projectOwner),
        felSubmittedBy: parseString(json.data.felSubmittedBy),
        projectManagerCapital: parseString(json.data.projectManagerCapital),
        site: parseString(json.data.site),
        gate: parseString(json.data.gate),
        projectType: parseString(json.data.projectType),
        unitName: parseString(json.data.unitName),
        totalInstalledCosts: parseString(json.data.totalInstalledCosts),
        estimateQuality: parseString(json.data.estimateQuality),
        majorCapital: parseString(json.data.majorCapital),
        fel1Accountable: parseString(json.data.fel1Accountable),
        estimatedCostForFel1: parseString(json.data.estimatedCostForFel1),
        riskLevel: parseString(json.data.riskLevel),
        turnaroundRequired: parseString(json.data.turnaroundRequired),
        turnaroundEvent: parseString(json.data.turnaroundEvent),
        scheduleConstraints: parseString(json.data.scheduleConstraints),
        riskThreatId: parseString(json.data.riskThreatId),
        actionItemId: parseString(json.data.actionItemId),
        actionItemDueDate: parseString(json.data.actionItemDueDate),
        mitigatedRisk: parseRiskScenarioRiskSelection(json.data.mitigatedRisk),
        mitigatedRiskJustification: parseString(
          json.data.mitigatedRiskJustification
        ),
        team:
          typeof json.data.team === 'object' && json.data.team !== null
            ? (json.data.team as Record<string, string>)
            : undefined,
        premise: parseString(json.data.premise),
        threatToPremise: parseString(json.data.threatToPremise),
        riskScenario: parseString(json.data.riskScenario),
        safeguards: parseString(json.data.safeguards),
        recommendedSolutions: parseString(json.data.recommendedSolutions),
        sustainingAdditionalInfo: parseString(
          json.data.sustainingAdditionalInfo
        ),
      },
      {
        organization: parseString(json.tags.organization) ?? '',
        site: parseString(json.tags.site) ?? '',
        unit: parseString(json.tags.unit),
      },
      {}
    )
  }

  public static CreateFromJSON(json: RolodexEntryJson) {
    return new GeckoRiskGate0Form(json)
  }
}
